import 'antd/dist/antd.less';
import React, { useEffect, useState, useCallback } from 'react';
import './App.less';
import { Routes, Route, useLocation } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch } from 'react-redux';

import Privacy from '../src/screen/auth/view/privacy';
import Onboarding from '../src/screen/auth/view/onboarding';
import EditProfile from './screen/auth/view/editProfile';
// import InventoryView from './screen/distributor/view/inventory/inventoryView';
// import InventoryViewCompany from './screen/distributor/view/inventory/inventoryViewCompany';
// import EditInvoice from './screen/distributor/view/invoices/editInvoice';
// import InvoiceDetails from './screen/distributor/view/invoices/invoiceDetails';
// import EditInvoiceDetails from './screen/distributor/view/invoices/editInvoiceDetails';
// import SearchBuyer from './screen/distributor/view/sell_to_buyer/searchBuyer';
// import AddBuyer from './screen/distributor/view/sell_to_buyer/addBuyer';
// import OnBoardingMason from './screen/distributor/view/sell_to_buyer/onboardingBuyer';
// import BuyerAddProduct from './screen/distributor/view/sell_to_buyer/BuyerAddProduct';
// import BuyerSellDetails from './screen/distributor/view/sell_to_buyer/BuyerSellDetails';
// import UserInvoices from './screen/distributor/view/invoices/userInvoice';
// import SingleInvoice from './screen/distributor/view/invoices/singleInvoice';
// import Transaction from './screen/distributor/view/transactions/transaction';
// import ViewOrders from './screen/distributor/view/orders/viewOrders';
// import OrderNow from './screen/distributor/view/orders/ordernow';
// import AddProducts from './screen/distributor/view/orders/addproducts';
// import Checkout from './screen/distributor/view/orders/checkout';
// import VerifyBuyer from './screen/distributor/view/sell_to_buyer/verifyBuyer';
// import SaleDetails from './screen/distributor/view/sale_agg/saleDetails';
// import SaleDetailsCompany from './screen/distributor/view/sale_agg/saleDetailsCompany';
// import OnboardingCompanyUser from './screen/auth/view/profile/onboardingCompanyUser';
// import VerifyRetailer from './screen/distributor/view/sell_to_buyer/verifyRetailer';
// import SellInvoices from './screen/distributor/view/invoices/sellInvoices';
// import Benefits from './screen/distributor/view/SchemeBenefit/Benefits';
// import PersonalProfiler from './screen/distributor/view/profiler/PersonalProfiler';
// import AllPersonalProfilers from './screen/distributor/view/profiler/AllPersonalProfilers';
// import AllBusinessProfilers from './screen/distributor/view/profiler/AllBusinessProfiler';
// import DownloadCertificate from './screen/distributor/view/SchemeBenefit/DownloadCertificate';
// import ShilpkarEdit from './screen/distributor/view/sell_to_buyer/shipkarEdit';
// import OrderBooking from './screen/distributor/view/orderBooking/orderBooking';
// import AddUserForOrder from './screen/distributor/view/orders/addUserForOrder';
// import LedgerBalance from './screen/distributor/view/ledgerbalance/LedgerBalance';
// import OrderDetails from './screen/distributor/view/orders/orderDetails';
// import ShipToPartyList from './screen/distributor/view/orders/ShipToPartyList';
// import PurchaseOrder from './screen/distributor/view/orderBooking/orderPurchase';
// import RetailerAssociateOrder from './screen/distributor/view/retailerAssociateOrder/retailerAssociateOrder';
// import AddProductForRetailerAndAssociate from './screen/distributor/view/retailerAssociateOrder/addProductForRetailerAndAssociate';
// import AllSecondaryOrders from './screen/distributor/view/retailerAssociateOrder/allsecondaryOrders';
// import ViewOrdersDispatchCompleted from './screen/distributor/view/orders/viewOrderDispatchCompleted';
// import SecondaryOrderDetails from './screen/distributor/view/retailerAssociateOrder/secondaryOrderDetails';
// import DownloadInsurance from './screen/distributor/view/downloadInsurance/downloadInsurance';
// import AllBenefits from './screen/distributor/view/SchemeBenefit/AllBenefits';
// import PLPView from './v2/PLP/view/PLPView';
// import PDPView from './v2/PDP/View/PDPView';
// import OrderBookingViewController from './v2/OrderBookingViewController/OrderBookingViewController';
// import FmcgBuyerSellDetails from './screen/distributor/view/sell_to_buyer/fmcgBuyerSellDetails';
// import Reports from './v2/Reports/View/Reports';
// import VcpPerformanceReport from './v2/Reports/View/VcpPerformanceReport';
// import PoPerformanceReport from './v2/Reports/View/PoPerfromanceReport';
// import VcpDetailedPerformance from './v2/Reports/View/VcpDetailedPerformance';
// import { onMessageListener } from './firebase';
// import Toast from './components/Toast/Toast';
// import AllGifts from './v2/Benefits/Rewards/AllGifts';

import i18n from '../src/translations/i18n';
import ResetPassword from './screen/auth/view/resetPassword';
import ChangePhoneNumber from './screen/auth/view/changePhoneNumbe';
import SingleGift from './v2/Benefits/Rewards/SingleGift';

import Notifications from './screen/distributor/view/notifications/notifications';
import ProductPricing from './screen/distributor/view/productPricing/productPricing';
import Payment from './screen/distributor/view/Payment/Payment';
import UserReports from './screen/distributor/view/UserReports/userReports';
import GoldenAgePlanListing from './screen/distributor/view/SchemeBenefit/goldenAgePlanListing';
import PaymentHistory from './screen/distributor/view/ledgerbalance/PaynentHistory';
import CartViewController from './v2/Inventory/CartViewController';
import Home from './v3/Home';

import FmcgInventory from './v2/FMCG/FmcgInventory';
import OrderComplete from './v2/FMCG/OrderComplete';
import LoginV2 from './v2/Onboarding/View/LoginV2';
import { Box, ThemeProvider } from '@mui/material';
// import theme from './theme';
import theme from './theme';
import VerifyV2 from './v2/Onboarding/View/VerifyV2';
import ForgotPasswordV2 from './v2/Onboarding/View/ForgotPasswordV2';
import RegisterV2 from './v2/Onboarding/View/RegisterV2';
import CreatePassword from './v2/Onboarding/View/CreatePassword';
import UserOnboarding from './v2/Onboarding/View/UserOnboarding';
import IndustrySelect from './v2/Onboarding/View/FirmOnboarding/industrySelect';
import SubIndustrySelect from './v2/Onboarding/View/FirmOnboarding/subIndustrySelect';
import CompanyAndRoleSelect from './v2/Onboarding/View/FirmOnboarding/companyAndRoleSelect';
import FetchFirmDetail from './v2/Onboarding/View/FirmOnboarding/fetchFirmDetail';
import FirmOnboarding from './v2/Onboarding/View/FirmOnboarding/firmOnboarding';
import FirmOnboardingSummary from './v2/Onboarding/View/FirmOnboarding/firmOnboardingSummary';
import POSelectIndustry from './v2/BCMOrder/POSelectIndustry';
import UserDetail from './v2/MyAccount/UserDetail';
import FirmDetail from './v2/MyAccount/FirmDetail';
import EmployeeDetails from './v2/MyAccount/EmployeeDetail';
import AddNewEmployee from './v2/MyAccount/AddNewEmployee';
import POBooking from './v2/BCMOrder/POBooking';
import PurchaseOrderList from './v2/BCMOrder/PurchaseOrdersList';
import PODetails from './v2/BCMOrder/PODetails';
import ChangeCredentials from './v2/MyAccount/ChangeCredential';
import { FAQ } from './v2/MyAccount/faq';
import ContactUsAndPolicies from './v2/MyAccount/ContactUsAndPolicies';
import SelectShipToParty from './v2/BCMOrder/SelectShipToParty';
import AddProduct from './v2/BCMOrder/AddProducts';
import ShipToPartyDetails from './v2/BCMOrder/ShipToPartyDetails';
import SelectedShipToPartyList from './v2/BCMOrder/SelectedShipToPartyList';
import DispatchStatusList from './v2/BCMOrder/DispatchStatusList';
import DispatchStatusDetails from './v2/BCMOrder/DispatchStatusDetails';
import ProductList from './v2/FMCG/ProductList';
import ProductDescription from './v2/FMCG/ProductDescription';
import OnboardBuyer from './v2/OnboardBuyer/OnboardBuyer';
import SecondaryOrderList from './v2/BCMOrder/SecondaryOrderList';
import AttachedOrders from './v2/BCMOrder/AttachedOrders';
import HumbeeBenefits from './v2/Benefits/HumbeeBenefits/HumbeeBenefits';

// import MyBenefitsOld from './v2/Benefits/MyBenefits/MyBenefits';
// import BeneficiaryDetails from './v2/Benefits/MyBenefits/BeneficiaryDetails';
// import AddNewBeneficiary from './v2/Benefits/MyBenefits/AddNewBeneficiary';
// import AvailableBenefits from './v2/Benefits/MyBenefits/AvailableBenefits';
// import BeneficiarySummary from './v2/Benefits/MyBenefits/BeneficiarySummary';
import InvoicesList from './v2/BCMOrder/InvoicesList';
import InvoiceDetailed from './v2/BCMOrder/InvoiceDetailed';
import KnowYouBetter from './v2/Profilers/View/KnowYouBetter';
import BusinessProfiler from './v2/Profilers/View/BusinessProfiler';
import AuthWrapper from './Layouts/AuthWrapper';
import NotFound from './v2/error/NotFound';
import { ToastContainer } from 'react-toastify';
import MyPerformance from './v2/Performance/View/MyPerformance';
import VcpPerformanceDirectory from './v2/Performance/View/VcpPerformanceDirectory';
import VcpSalesDashBoard from './v2/Performance/View/VcpSalesDashBoard';
import PoPerformanceDetails from './v2/Performance/View/PoPerformanceDetails';
import GlobalWrapper from './Layouts/GlobalWrapper';

import MainLayout from './Layouts/MainLayout';
import MyBusinessSideBar from './v2/SideBar/myBusinessSideBar';
import MyRewards from './v2/Benefits/Rewards/MyRewards';
import RewardDetails from './v2/Benefits/Rewards/RewardDetails';
import RewardHistory from './v2/Benefits/Rewards/RewardHistory';
import MyNetwork from './v2/Benefits/Rewards/MyNetworkRewards';
import Overview from './v2/Benefits/BenefitsRevamp/Overview';
import GapCalculator from './v2/Benefits/BenefitsRevamp/GapCalculator';
import PWASubMenu from './v2/GlobalSidebar/PWASubMenu';
import MainMenuScreen from './v2/GlobalSidebar/PWAMainSidebar';
import { decodeToken } from './utils/settings';
import TempTnc from './v2/Benefits/BenefitsRevamp/TempTnc';
import ScrollToTop from './v2/ScrollTop';

import PWAFAQ from './v2/FAQ/PWAFaq';
import Benefits from './v2/Benefits/Beneficiary/Benefits';
import AddBeneficiary from './v2/Benefits/Beneficiary/AddBeneficiary';
import AddNominee from './v2/Benefits/Beneficiary/AddNominee';
import BeneficiaryDetail from './v2/Benefits/Beneficiary/BeneficiaryDetail';

import AddBankDetails from './v2/Benefits/Beneficiary/AddBankDetails';
import MyBenefits from './v2/Benefits/BenefitsRevamp/MyBenefits';
import LIMIDetailPage from './v2/Benefits/BenefitsRevamp/Components/LIMIDetailPage';
import GAPDetailPage from './v2/Benefits/BenefitsRevamp/Components/GAPDetailPage';
import CumulativeTDS from './v2/Benefits/BenefitsRevamp/CumulativeTDS';

import NetworkInfluencer from './v2/Benefits/Rewards/NetworkInfluencer';
import CompanyWiseInventory from './v3/Inventory/CompanyWiseInventory';
import Inventory from './v3/Inventory/Inventory';
import InventoryCart from './v3/Inventory/InventoryCart';
import InventoryCheckout from './v3/Inventory/InventoryCheckout';
import SelectSTP from './v3/Inventory/SelectSTP';
import SelectedSTP from './v3/Inventory/SelectedSTP';
import CompletedOrder from './v3/Inventory/CompletedOrder';
import ServiceUnavailable from './v2/Benefits/Beneficiary/Components/ServiceUnavailable';
import HomeLayout from './Layouts/HomeLayout';

import { GetMeAction } from './v2/Onboarding/auth/action';
import { initializeCleverTapAction, trackAnalyticsEvent, trackAnalyticsEventWithUserData, trackPWAModuleDetection, trackUserLogout } from './utils/clevertap/clevertapUtils';
import { loadCleverTapSDK } from './utils/clevertap/clevertapConfig';
import { setPWAAction } from './screen/auth/action';
import Profile from './v3/Profile';
import ComponentShowcase from './v2/MUI_custom_component/ComponentShowcase';
import ShopInsurance from './v3/Beneficiary/ShopInsurance/ShopInsurance';
import ShopInsuranceDetails from './v3/Beneficiary/ShopInsurance/ShopInsuranceDetails';
import NetworkHospitalPage from './v2/Benefits/BenefitsRevamp/Components/NetworkHospitalPage';
import StaffInsurance from './v3/Beneficiary/StaffInsurance';

function App() {
  const dispatch = useDispatch();
  const language = localStorage.getItem('language');
  if (language) {
    i18n.changeLanguage(language);
  }

  useEffect(() => {
    if (process.env.REACT_APP_PROD === 'true') {
      const handleContextMenu = (event) => {
        event.preventDefault();
      };

      document.addEventListener('contextmenu', handleContextMenu);

      return () => {
        document.removeEventListener('contextmenu', handleContextMenu);
      };
    }
  }, []);
  useEffect(() => {
    if (process.env.REACT_APP_PROD === 'true') {
      const handleCopy = (event) => {
        event.preventDefault();
      };

      const handleCut = (event) => {
        event.preventDefault();
      };

      const handlePaste = (event) => {
        event.preventDefault();
      };

      document.addEventListener('copy', handleCopy);
      document.addEventListener('cut', handleCut);
      document.addEventListener('paste', handlePaste);

      return () => {
        document.removeEventListener('copy', handleCopy);
        document.removeEventListener('cut', handleCut);
        document.removeEventListener('paste', handlePaste);
      };
    }
  }, []);


  const getUserLoggedInData = async() => { 
    const { data: loggedInUser } = await GetMeAction();
    dispatch({ type: 'SET_USER', data: loggedInUser });
  }
  // PWA Setup
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const pwaJwt = searchParams.get('token');
  
    // Initialize CleverTap SDK on app startup
  useEffect(() => {
    const initializeCleverTap = async () => {
      try {
        await loadCleverTapSDK();
        
        // For PWA users, ensure any previous session is cleared immediately
        // This is an extra safety measure for PWA fresh starts
        if (pwaJwt || window.location.search.includes('token=')) {
          trackUserLogout('pwa_sdk_initialization');
        }
        
        // Only track PWA app launch for PWA users after SDK loads
        // Will be called again when tokenData is available
      } catch (error) {
        // Silent fail
      }
    };

    initializeCleverTap();
  }, [pwaJwt]);
  // Store token but don't track event yet - wait for CleverTap SDK to load
  if (pwaJwt) {
    localStorage.setItem('token', pwaJwt);
  }

  const [tokenData, setTokenData] = useState({});

  // const getTokenData = async () => {
  //   const decoded = await decodeToken();
  //   setTokenData(decoded);
  // };
  const [pwaDetected, setPwaDetected] = useState(false); // Flag to prevent duplicate PWA detection events

  useEffect(() => {
    let isMounted = true;
    
    const fetchTokenData = async () => {
      try {
        const decoded = await decodeToken();
        if (isMounted) {
          console.log('Decoded token data:', decoded);
          setTokenData(decoded);
        }
      } catch (error) {
        // Handle error silently
      }
    };
    
    fetchTokenData();
    
    return () => {
      isMounted = false;
    };
  }, []);

  // Track PWA detection only once when tokenData changes
  useEffect(() => {
    if (tokenData && tokenData?.pwa_module && !pwaDetected) {
      // Set flag to prevent duplicate events - but don't track event yet
      // Event will be tracked after user profile is initialized in getUserDataForPWA
      getUserLoggedInData();
      setPwaDetected(true);
    }
  }, [tokenData, pwaDetected]);

  let isPwa = false;
  if (tokenData && tokenData?.pwa_module) {
    isPwa = true;
    // Dispatch PWA state to Redux
    dispatch(setPWAAction(true));
    
  } else {
    // Ensure PWA state is false for non-PWA users
    dispatch(setPWAAction(false));
  }


  const getUserDataForPWA = useCallback(async () => {
    try {
      // CRITICAL: Track logout event for existing session before clearing it
      // This ensures proper analytics for PWA fresh starts
      trackUserLogout('pwa_fresh_start');
      
      // Small delay to ensure logout is processed before new session starts
      await new Promise(resolve => setTimeout(resolve, 200));
      
      const { error: userError, data: loggedInUser } = await GetMeAction();

      if (!userError && loggedInUser) {
        // Create user profile for CleverTap tracking - PWA users only
        const userProfileData = {
          user_id: loggedInUser.user_id || tokenData?.user_id,
          id: loggedInUser.user_id || tokenData?.user_id,
          first_name: loggedInUser.first_name,
          last_name: loggedInUser.last_name,
          email: loggedInUser.email,
          phone_no: loggedInUser.phone_no,
          is_verified: loggedInUser.is_verified || false,
          is_onboarded: loggedInUser.is_onboarded || false,
          // PWA specific data
          pwa_module: true,
          access_type: 'pwa',
        };

        await initializeCleverTapAction(userProfileData);
        
        // Track PWA module detection after user profile is initialized
        trackPWAModuleDetection(userProfileData, 'token_data');
        
        // Track PWA app launch after CleverTap is initialized
        trackAnalyticsEvent('PWA_APP_LAUNCH', {
          user_agent: navigator.userAgent,
          referrer: document.referrer || 'direct'
        });
        
        // Track PWA access via token if applicable
        if (pwaJwt) {
          trackAnalyticsEvent('PWA_ACCESS_VIA_TOKEN', {
            referrer: document.referrer || 'direct',
            token_source: 'url_parameter'
          });
        }
        
      } else if (tokenData?.user_id && tokenData?.phone_number) {
        // For cases where GetMeAction fails but we have token data (PWA users)
        const minimalUserProfile = {
          user_id: tokenData.user_id,
          id: tokenData.id,
          phone_no: tokenData.phone_number,
          pwa_module: true,
          access_type: 'pwa',
        };

        await initializeCleverTapAction(minimalUserProfile);
        
        // Track PWA module detection after user profile is initialized
        trackPWAModuleDetection(minimalUserProfile, 'token_data_minimal');
        
        // Track PWA app launch after CleverTap is initialized
        trackAnalyticsEvent('PWA_APP_LAUNCH', {
          user_agent: navigator.userAgent,
          referrer: document.referrer || 'direct'
        });
        
        // Track PWA access via token if applicable
        if (pwaJwt) {
          trackAnalyticsEvent('PWA_ACCESS_VIA_TOKEN', {
            referrer: document.referrer || 'direct',
            token_source: 'url_parameter'
          });
        }
      }
    } catch (error) {
      // Even if API fails, try to track basic PWA events with token data
      if (tokenData?.user_id) {
        // Track PWA app launch
        trackAnalyticsEvent('PWA_APP_LAUNCH', {
          user_agent: navigator.userAgent,
          referrer: document.referrer || 'direct',
          user_id: tokenData?.user_id
        });
        
        // Track PWA access via token if applicable
        if (pwaJwt) {
          trackAnalyticsEvent('PWA_ACCESS_VIA_TOKEN', {
            referrer: document.referrer || 'direct',
            token_source: 'url_parameter',
            user_id: tokenData?.user_id
          });
        }
      }
    }
  }, [tokenData, pwaJwt]);

  useEffect(() => {
    let isMounted = true;
    
    // Only initialize CleverTap for PWA users on app load
    // Regular login users will be handled in the login flow
    if (tokenData?.pwa_module && tokenData?.user_id) {
      const initializePWAUser = async () => {
        try {
          if (isMounted) {
            await getUserDataForPWA();
          }
        } catch (error) {
          // Silent fail
        }
      };
      initializePWAUser();
    }
    
    return () => {
      isMounted = false;
    };
  }, [tokenData, getUserDataForPWA]);

  const routes = {
    basicRoutes: [
      { path: '/resetpassword', element: <ResetPassword /> },
      { path: '/changeNumber', element: <ChangePhoneNumber /> },
      { path: '/onboarding', element: <Onboarding />, moduleKey: 'onboard-buyer', },
      { path: '/editonboarding', element: <EditProfile /> },
      { path: '/onboard-buyer', element: <OnboardBuyer />, showMenu: false, moduleKey: 'onboard-buyer', },
      { path: '/humbee-benefits', element: <HumbeeBenefits /> },
    ],
    HomeRoute: [
      { path: '/', element: <Home /> },
    ],
    authRoutes: [
      { path: '/privacy', element: <Privacy /> },
      { path: '/login', element: <LoginV2 /> },
      { path: '/LoginViaOtp', element: <VerifyV2 /> },
      { path: '/VerifyUserForForgotPassword', element: <VerifyV2 /> },
      { path: '/VerifyUserForRegister', element: <VerifyV2 /> },
      { path: '/ForgotPassword', element: <ForgotPasswordV2 /> },
      { path: '/Register', element: <RegisterV2 /> },
      { path: '/CreatePassword', element: <CreatePassword /> },
      { path: '/UserOnboarding', element: <UserOnboarding /> },
      { path: '/IndustrySelect', element: <IndustrySelect /> },
      { path: '/SubIndustrySelect', element: <SubIndustrySelect /> },
      { path: '/CompanyAndRoleSelect', element: <CompanyAndRoleSelect /> },
      { path: '/FetchFirmDetail', element: <FetchFirmDetail /> },
      { path: '/FirmOnboarding', element: <FirmOnboarding /> },
      { path: '/FirmOnboardingSummary', element: <FirmOnboardingSummary /> },
      { path: '*', element: <NotFound /> },
    ],
    myBussinessRoutes: [
      { path: '/distributor/payment', element: <Payment /> },
      {
        path: '/order-booking/po-select-industry',
        element: <POSelectIndustry />,
      },
      { path: '/order-booking/po-booking', element: <POBooking /> },
      { path: '/order-booking/po-details', element: <PODetails /> },
      { path: '/order-booking/attached-orders', element: <AttachedOrders /> },

      {
        path: '/order-booking/select-ship-to-party/secondary-order',
        element: <SelectShipToParty />,
      },
      {
        path: '/order-booking/selected-ship-to-party-list',
        element: <SelectedShipToPartyList />,
      },

      {
        path: '/order-booking/dispatch-status-list',
        element: <DispatchStatusList />,
      },
      { path: '/order-booking/completed-invoices', element: <InvoicesList /> },
      {
        path: '/order-booking/invoice-details/:id',
        element: <InvoiceDetailed />,
      },
      {
        path: '/order-booking/dispatch-status-details',
        element: <DispatchStatusDetails />,
      },
      { path: '/order-booking/add-products', element: <AddProduct /> },
      { path: '/order-booking/po-list', element: <PurchaseOrderList /> },
      {
        path: '/order-booking/secondar-orders-list',
        element: <SecondaryOrderList />,
      },
      { path: '/order-booking/product-list', element: <ProductList /> },
      {
        path: '/order-booking/product-description',
        element: <ProductDescription />,
      },
      { path: '/distributor/productPricing', element: <ProductPricing /> },
      { path: '/distributor/paymentHistory', element: <PaymentHistory /> },
      { path: '/distributor/userReports', element: <UserReports /> },
    ],
    inventoryRoutes: [
      {
        path: '/inventory',
        element: <Inventory />,
        title: 'Inventory',
        backroute: isPwa ? '/pwa-main-menu': null,
        moduleKey: 'business',
      },
      {
        path: 'inventory/company-inventory',
        element: <CompanyWiseInventory /> ,
        title: 'Inventory',
        moduleKey: 'business',
        backroute: '/inventory',
      },
      {
        path: 'inventory/cart',
        element: <InventoryCart />,
        title: 'Inventory',
        moduleKey: 'business',
        backroute: '/inventory/company-inventory',
      },
      {
        path: 'inventory/select-ship-to-party',
        element: <SelectSTP />,
        title: 'Inventory',
        moduleKey: 'business',
        backroute: '/inventory/cart',
      },
      {
        path: '/inventory/selected-ship-to-party',
        element: <SelectedSTP />,
        title: 'Inventory',
        moduleKey: 'business',
        backroute: '/inventory/select-ship-to-party',
      },
      {
        path: 'inventory/checkout',
        element: <InventoryCheckout />,
        title: 'Inventory',
        moduleKey: 'business',
        // backroute: '/inventory/select-ship-to-party',
      },
      {
        path: 'inventory/order-completed',
        element: <CompletedOrder />,
        moduleKey: 'business',
      },
      
      {
        path: '/order-booking/ship-to-party-details',
        element: <ShipToPartyDetails />,
        title: 'Ship To Party Details',
      },
      {
        path: '/order-booking/select-ship-to-party',
        element: <SelectShipToParty />,
        title: 'Select Ship To Party',
      },
      { path: '/fmcg/order-completed', element: <OrderComplete /> },
      {
        path: '/fmcg/inventory',
        element: <FmcgInventory />,
        title: 'Inventory',
      },
      {
        path: '/distributor/company-wise-inventory',
        element: <CompanyWiseInventory />,
        title: 'Company Wise Inventory ',
        backroute: isPwa ? '/pwa-main-menu' : null,
      },
    ],
    distributorRoutes: [
      { path: '/distributor/notifications', element: <Notifications /> },
      {
        path: '/distributor/GoldenAgePlanListing',
        element: <GoldenAgePlanListing />,
      },
    ],
    myPerformanceRoutes: [
      {
        path: '/my-performance/Performance',
        element: <MyPerformance />,
        title: 'Performance',
        moduleKey: 'analytics',
      },
      {
        path: 'my-performance/network-performance',
        element: <VcpPerformanceDirectory />,
        title: 'Performance',
        backroute: isPwa ? '/pwa-main-menu' : null,
        moduleKey: 'analytics',
      },
      {
        path: '/my-performance/VCPSalesDashBoard',
        element: <VcpSalesDashBoard />,
        title: 'Performance',
        moduleKey: 'analytics',
      },
      {
        path: '/my-performance/PoPerformanceDetails',
        element: <PoPerformanceDetails />,
        title: 'Performance',
        moduleKey: 'analytics',
      },
    ],
    myBenefitsRoutes: [
      {
        path: '/benefits/network-rewards',
        element: <NetworkInfluencer />,
        title: 'Network Rewards',
        backroute: isPwa ? '/pwa-main-menu' : null,
        moduleKey: 'humbee-benefits',
      },
      {
        path: '/benefits/rewards-history',
        element: <RewardHistory />,
        title: 'Reward History',
        moduleKey: 'humbee-benefits',
      },
      {
        path: '/benefits/rewards',
        element: <MyRewards />,
        title: 'My Rewards',
        backroute: isPwa ? '/pwa-main-menu' : null,
        moduleKey: 'humbee-benefits',
      },
      {
        path: '/benefits/reward-detail',
        element: <RewardDetails />,
        title: 'Reward Details',
        moduleKey: 'humbee-benefits',
      },

      {
        path: '/benefits/network-influencer',
        element: <MyNetwork />,
        title: 'Network Rewards',
        moduleKey: 'humbee-benefits',
      },
      {
        path: '/benefits/insurance-detail',
        element: <LIMIDetailPage />,
        title: 'My Benefits',
        moduleKey: 'humbee-benefits',
      },
      {
        path: '/benefits/gap-detail',
        element: <GAPDetailPage />,
        title: 'My Benefits',
        moduleKey: 'humbee-benefits',
      },
      {
        path: '/benefits/mybenefits',
        element: <MyBenefits />,
        title: 'My Benefits',
        backroute: isPwa ? '/pwa-main-menu' : null,
        moduleKey: 'humbee-benefits',
      },
      { path: '/benefits/overview', element: <Overview />, title: 'Overview', moduleKey: 'humbee-benefits', },
      {
        path: '/benefits/Tnc',
        element: <TempTnc />,
        title: 'Terms & Conditions',
        moduleKey: 'humbee-benefits',
      },
      {
        path: '/benefits/gap-calculator',
        element: <GapCalculator />,
        title: 'Gap Calculator',
        moduleKey: 'humbee-benefits',
      },
      {
        path: '/benefits/cumulative-tds',
        element: <CumulativeTDS />,
        title: 'Cumulative TDS',
        moduleKey: 'humbee-benefits',
      },
      {
        path: '/distributor/giftsdetails',
        element: <SingleGift />,
        title: 'Gift Details',
        moduleKey: 'humbee-benefits',
      },
      {
        path: '/beneficiary',
        element: <Benefits />,
        title: 'Beneficiary',
        backroute: isPwa ? '/pwa-main-menu' : null,
        moduleKey: 'humbee-benefits',
      },
      {
        path: '/beneficiary/add-beneficiary',
        element: <AddBeneficiary />,
        title: 'Beneficiary',
        backroute: '/beneficiary',
        moduleKey: 'humbee-benefits',
      },
      {
        path: '/beneficiary/add-nominee',
        element: <AddNominee />,
        title: 'Beneficiary',
        backroute: '/beneficiary',
        moduleKey: 'humbee-benefits',
      },
      {
        path: '/beneficiary/add-bank-details',
        element: <AddBankDetails />,
        title: 'Beneficiary',
        backroute: '/beneficiary',
        moduleKey: 'humbee-benefits',
      },
      {
        path: '/beneficiary/detail',
        element: <BeneficiaryDetail />,
        title: 'Beneficiary',
        backroute: '/beneficiary',
        moduleKey: 'humbee-benefits',
      },
      {
        path: '/serviceunavailable',
        element: <ServiceUnavailable />,
        title: 'Service Unavailable',
        backroute: '/beneficiary',
        moduleKey: 'humbee-benefits',
      },
      {
        path: '/beneficiary/add-shop-details',
        element: <ShopInsurance />,
        title: 'Beneficiary',
        // backroute: '/beneficiary',
        moduleKey: 'humbee-benefits',
      },
      {
        path: '/beneficiary/shop-details',
        element: <ShopInsuranceDetails />,
        title: 'Beneficiary',
        // backroute: '/beneficiary',
        moduleKey: 'humbee-benefits',
      },
      {
        path: '/beneficiary/staff-details',
        element: <StaffInsurance />,
        title: 'Beneficiary',
        // backroute: '/beneficiary',
        moduleKey: 'humbee-benefits',
      },
      {
        path: '/benefits/network-hospital',
        element: <NetworkHospitalPage />,
        title: 'My Benefits',
        moduleKey: 'humbee-benefits',
      },
    ],
    myAccountsRoutes: [
      // { path: '/my-account/user-details', element: <UserDetail /> },
      { path: '/profile', element: <Profile />, title: 'Profile', moduleKey: 'my-account', title: "Profile", showMenu: false},
      { path: '/my-account/firm-details', element: <FirmDetail />, backroute: '/profile',  moduleKey: 'my-account',title: "Profile" , showMenu: false  },
      { path: '/my-account/employee-details', element: <EmployeeDetails />, backroute: '/profile',  moduleKey: 'my-account', title: "Profile",  showMenu: false   },
      { path: '/my-account/firm-details/add', element: <AddNewEmployee />, backroute: '/profile',  moduleKey: 'my-account',  title: "Profile",  showMenu: false  },
      {
        path: '/my-account/change-credentials',
        element: <ChangeCredentials />,
        backroute: '/profile',  moduleKey: 'my-account', 
        title: "Profile" ,
        showMenu: false
      },
      { path: '/my-account/faq', element: <FAQ />,
        backroute: '/profile',  moduleKey: 'my-account',
        title: "Profile",
        showMenu: false
       },
      {
        path: '/my-account/contact-us-and-policies',
        element: <ContactUsAndPolicies />,
        backroute: '/profile',  moduleKey: 'my-account', 
        title: "Profile",
        showMenu: false
      },
      { path: '/my-account/know-you-better', element: <KnowYouBetter /> ,
        backroute: '/profile' , moduleKey: 'my-account', 
        title: "Profile",
        showMenu: false
      },
      { path: '/my-account/business-profiler', element: <BusinessProfiler />,
        backroute: '/profile',
        moduleKey: 'my-account', 
        title: "Profile",
        showMenu: false
       },
    ],
    PWARoute: [
      {
        path: '/pwa-main-menu',
        // element: <MainMenuScreen />,
        element: <Home />,
      },
    ],
    PWAAddons: [
      {
        path: '/pwa-faq',
        element: <PWAFAQ />,
        title: 'FAQ',
        backroute: '/pwa-main-menu',
        showMenu: false 

      },
    ],
     component: [
      {
        path: '/humbee-design-system',
        element: <ComponentShowcase />,
        title: 'Humbee Design System',
      },
    ],
      // {path: '/pwa-mybenefit', element: <SinglePageBenefits />, title: 'My Benefits', backroute: '/pwa-main-menu'},
  };
  return (
    <Box className='App' 
      sx={{
        position: 'relative',
        backgroundColor: '#FAFAFA',
        '&::before': {
          content: '""',
          position: 'absolute',
          inset: 0,
          // background: 'linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 164, 37, 0.4) 100%)',
          background: `linear-gradient(178.79deg, rgba(255, 255, 255, 0) 24.32%, rgba(255, 165, 37, 1) 98.24%)`,
          opacity: 0.1,
          pointerEvents: 'none',
        },
        
        height:{ xs:'auto' , md: '100vh'},
      }}
    >
      <ThemeProvider theme={theme}>
       <ToastContainer
        autoClose={10000}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        style={{ zIndex: 20000 }} // must be higher than MUI modal
      />
        <ScrollToTop />
          <Routes>
            {routes.HomeRoute.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={
                  <HomeLayout 
                    sidebarTitle={route?.title}
                    isPwa={isPwa}
                    backroute={route?.backroute}
                    moduleKey={null}
                    isHomePage={true}
                  >
                    {route.element}
                  </HomeLayout>
                }
              />
            ))}
            {routes.basicRoutes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={
                  <MainLayout
                    sidebarTitle={route?.title}
                    isPwa={isPwa}
                    backroute={route?.backroute}
                    moduleKey={route?.moduleKey}
                    showMenu={route?.showMenu}
                  >
                    {route.element}
                  </MainLayout>
                }
              />
            ))}

            {routes.myBussinessRoutes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={
                  <MainLayout
                    sidebarTitle={route?.title}
                    isPwa={isPwa}
                    backroute={route?.backroute}
                    moduleKey={null}
                    isHomePage={true}
                    showMenu={route?.showMenu}
                    // SidebarComponent={MyBusinessSideBar}
                    // sidebarTitle={route?.title ? route?.title : 'My Business'}
                    // backroute={route?.backroute}
                  >
                    {route.element}
                  </MainLayout>
                }
              />
            ))}
            {routes.inventoryRoutes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={
                  <MainLayout  moduleKey={route?.moduleKey} sidebarTitle={route?.title} backroute={route?.backroute} isPwa={isPwa}>
                    {route.element}
                  </MainLayout>
                }
              />
            ))}
            {routes.distributorRoutes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={
                  <MainLayout 
                    sidebarTitle={route?.title}
                    moduleKey={route?.moduleKey}
                    backroute={route?.backroute} 
                    isPwa={isPwa}
                  >
                    {route.element}
                  </MainLayout>
                }
              />
            ))}
            {routes.myPerformanceRoutes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={
                  <MainLayout 
                    sidebarTitle={route?.title} 
                    backroute={route?.backroute}  
                    moduleKey={route?.moduleKey} 
                    isPwa={isPwa}
                    isHomePage={false}
                  >
                    {route.element}
                  </MainLayout>
                }
              />
            ))}
            {routes.myBenefitsRoutes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={
                  <MainLayout 
                    sidebarTitle={route?.title}
                    backroute={route?.backroute}
                    isPwa={isPwa}
                    moduleKey={route?.moduleKey}
                  >
                    {route.element}
                  </MainLayout>
                }
              />
            ))}
            {routes.myAccountsRoutes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={
                  <MainLayout
                    sidebarTitle={route?.title ? route?.title :'Manage Your Account'}
                    backroute={route?.backroute}
                    isPwa={isPwa}
                    moduleKey={route?.moduleKey}
                    showMenu={route?.showMenu}
                  >
                    {route.element}
                  </MainLayout>
                }
              />
            ))}
            {routes.authRoutes.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={<AuthWrapper>{route.element}</AuthWrapper>}
              />
            ))}
            {routes.PWARoute.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={
                  <MainLayout
                    sidebarTitle={route?.title}
                    isPwa={isPwa}
                    backroute={route?.backroute}
                    moduleKey={null}
                    isHomePage={true}
                    showMenu={route?.showMenu}
                  >
                   {route.element}
                  </MainLayout>
                }
              />
            ))}
            {routes.PWAAddons.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={
                  <MainLayout
                    sidebarTitle={route?.title}
                    isPwa={isPwa}
                    backroute={route?.backroute}
                    moduleKey={null}
                    isHomePage={false}
                    showMenu={route?.showMenu}
                  >
                    {route.element}
                  </MainLayout>
                }
              />
            ))}
            {routes.component.map((route, index) => (
              <Route
                key={index}
                path={route.path}
                element={
                  <MainLayout
                    sidebarTitle={route?.title}
                    isPwa={isPwa}
                    backroute={route?.backroute}
                    moduleKey={null}
                    isHomePage={false}
                  >
                    {route.element}
                  </MainLayout>
                }
              />
            ))}
          </Routes>
      </ThemeProvider>
    </Box>
  );
}

export default App;

// //Messages
// const [show, setShow] = useState(false);
// const [notification, setNotification] = useState({title: '', body: ''});
// const [isTokenFound, setTokenFound] = useState(false);

// // const userToken = localStorage.getItem("message_token") && setTokenFound(true);
// const userToken = localStorage.getItem("message_token")
// // fetchToken(setTokenFound);

// useEffect(() => {
//   if (!userToken) {
//     fetchToken(setTokenFound);
//   } else {
//     console.log("userToken", userToken)
//   }
// }, []);

// // fetchToken(setTokenFound);

// onMessageListener().then(payload => {
//   setNotification({title: payload.notification.title, body: payload.notification.body})
//   setShow(true);
//   console.log("payload",payload);
// }).catch(err => console.log('failed: ', err));

// const onShowNotificationClicked = () => {
//   setNotification({title: "Notification", body: "This is a test notification"})
//   setShow(true);
// }

///////////////////////////////////////////////////////////////////////////////////
// //request notification permission
// useEffect(() => {
//   if (!tokenFound) {
//     notification.requestPermission().then(permission => {
//       if (permission === 'granted') {
//         fetchToken(setTokenFound);
//       }
//     });
//   }
// }
// , []);

// const { loginUser } = useSelector((state) => {
//   return {
//     loginUser: state.loginReducer.loginUser,
//   };
// });

// let userToken
// useEffect(() => {
//   // fetchToken(setTokenFound);
//   userToken = localStorage.getItem("message_token")
//   // console.log(userToken?.length)

// }, []);

// useEffect(() => {
//     if(userToken?.length < 10 || userToken === null) {
//       fetchToken(setTokenFound);
//     }
// }, []);

// const saveToken = async () => {
//   const usrtoken = JSON.parse(userToken);
//   const response = await registerNotificationToken(usrtoken, "userToken");
//   console.log('response: ', response);
// }

// useEffect(() => {
//   saveToken();
// }, [userToken]);
